/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DownloadDetailsRequestBuilderRequestsMetadata, type DownloadDetailsRequestBuilder } from './downloadDetails/index.js';
// @ts-ignore
import { GetRequestBuilderRequestsMetadata, type GetRequestBuilder } from './get/index.js';
// @ts-ignore
import { GetBookingStatusRequestBuilderRequestsMetadata, type GetBookingStatusRequestBuilder } from './getBookingStatus/index.js';
// @ts-ignore
import { GetDetailsRequestBuilderRequestsMetadata, type GetDetailsRequestBuilder } from './getDetails/index.js';
// @ts-ignore
import { GetHistoryRequestBuilderRequestsMetadata, type GetHistoryRequestBuilder } from './getHistory/index.js';
// @ts-ignore
import { GetMessagesRequestBuilderRequestsMetadata, type GetMessagesRequestBuilder } from './getMessages/index.js';
// @ts-ignore
import { GetVerificationsRequestBuilderRequestsMetadata, type GetVerificationsRequestBuilder } from './getVerifications/index.js';
// @ts-ignore
import { RetryRequestBuilderRequestsMetadata, type RetryRequestBuilder } from './retry/index.js';
// @ts-ignore
import { SendMessageRequestBuilderRequestsMetadata, type SendMessageRequestBuilder } from './sendMessage/index.js';
// @ts-ignore
import { type UpdateStatusRequestBuilder, UpdateStatusRequestBuilderRequestsMetadata } from './updateStatus/index.js';
// @ts-ignore
import { type VerifyRequestBuilder, VerifyRequestBuilderRequestsMetadata } from './verify/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard
 */
export interface DashboardRequestBuilder extends BaseRequestBuilder<DashboardRequestBuilder> {
    /**
     * The DownloadDetails property
     */
    get downloadDetails(): DownloadDetailsRequestBuilder;
    /**
     * The GetBookingStatus property
     */
    get getBookingStatus(): GetBookingStatusRequestBuilder;
    /**
     * The GetDetails property
     */
    get getDetails(): GetDetailsRequestBuilder;
    /**
     * The GetHistory property
     */
    get getHistory(): GetHistoryRequestBuilder;
    /**
     * The GetMessages property
     */
    get getMessages(): GetMessagesRequestBuilder;
    /**
     * The GetPath property
     */
    get getPath(): GetRequestBuilder;
    /**
     * The GetVerifications property
     */
    get getVerifications(): GetVerificationsRequestBuilder;
    /**
     * The Retry property
     */
    get retry(): RetryRequestBuilder;
    /**
     * The SendMessage property
     */
    get sendMessage(): SendMessageRequestBuilder;
    /**
     * The UpdateStatus property
     */
    get updateStatus(): UpdateStatusRequestBuilder;
    /**
     * The Verify property
     */
    get verify(): VerifyRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DashboardRequestBuilderUriTemplate = "{+baseurl}/Dashboard";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DashboardRequestBuilderNavigationMetadata: Record<Exclude<keyof DashboardRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    downloadDetails: {
        requestsMetadata: DownloadDetailsRequestBuilderRequestsMetadata,
    },
    getBookingStatus: {
        requestsMetadata: GetBookingStatusRequestBuilderRequestsMetadata,
    },
    getDetails: {
        requestsMetadata: GetDetailsRequestBuilderRequestsMetadata,
    },
    getHistory: {
        requestsMetadata: GetHistoryRequestBuilderRequestsMetadata,
    },
    getMessages: {
        requestsMetadata: GetMessagesRequestBuilderRequestsMetadata,
    },
    getPath: {
        requestsMetadata: GetRequestBuilderRequestsMetadata,
    },
    getVerifications: {
        requestsMetadata: GetVerificationsRequestBuilderRequestsMetadata,
    },
    retry: {
        requestsMetadata: RetryRequestBuilderRequestsMetadata,
    },
    sendMessage: {
        requestsMetadata: SendMessageRequestBuilderRequestsMetadata,
    },
    updateStatus: {
        requestsMetadata: UpdateStatusRequestBuilderRequestsMetadata,
    },
    verify: {
        requestsMetadata: VerifyRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
